/** Browser error reporting: window errors, unhandled promise rejections and React render crashes go to the server. */
const seen = new Set<string>();
/** Last few errors, attached to problem reports (see components/FeedbackDialog). */
const recent: string[] = [];
export const recentErrors = () => recent.slice();

export function reportError(err: unknown, extra?: string) {
  try {
    const e = err instanceof Error ? err : new Error(typeof err === "string" ? err : JSON.stringify(err));
    const key = `${e.message}|${(e.stack ?? "").split("\n")[1] ?? ""}`;
    recent.push(`${new Date().toISOString()} ${e.message.slice(0, 300)}`);
    if (recent.length > 8) recent.shift();
    if (seen.has(key) || seen.size > 20) return;
    seen.add(key);
    if (/ResizeObserver loop|Load failed|NetworkError|Failed to fetch|AbortError/.test(e.message)) return;
    const body = JSON.stringify({
      message: e.message.slice(0, 1000),
      stack: (e.stack ?? "").slice(0, 8000),
      url: location.href,
      userAgent: navigator.userAgent,
      version: typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "dev",
      extra,
    });
    if (navigator.sendBeacon)
      navigator.sendBeacon("/api/client-errors", new Blob([body], { type: "application/json" }));
    else
      void fetch("/api/client-errors", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      });
  } catch {}
}

export function installErrorReporting() {
  window.addEventListener("error", (ev) => reportError(ev.error ?? ev.message));
  window.addEventListener("unhandledrejection", (ev) => reportError(ev.reason));
}
